module.exports = __webpack_public_path__ + "static/media/intro.663525cc.mp3";